"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutateUpdateUserAttributes = void 0;
const util_1 = require("@app/util");
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
// $type: CustomAttributeValueType!
const userAttributeUpdate = (0, graphql_tag_1.default) `mutation UserAttributeUpdate(
    $workspaceId: ID!,
    $id: ID!,
    $name: String,
    $shortName: String,
    $description: String,
    $customId: String,
    $hidden: Boolean,
    $options: CustomAttributeOptionsInput
    ) {
      userAttributeUpdate(
        workspace: $workspaceId,
        id: $id,
        name: $name,
        shortName: $shortName,
        description: $description,
        customId: $customId,
        hidden: $hidden,
        options: $options
        ) {
          id
          name
          description
          shortName
          customId
          type
          options {
            values
          }
          hidden
      }
}`;
const mutateUpdateUserAttributes = async (variables) => {
    const { data, errors } = await (0, apollo_1.query)(userAttributeUpdate, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.userAttributeUpdate;
};
exports.mutateUpdateUserAttributes = mutateUpdateUserAttributes;
/**
* @deprecated Use `mutateUpdateUserAttributes` instead
*/
async function updateUserAttributes(variables) {
    const response = await (0, util_1.fetchRequest)({ query: userAttributeUpdate, variables });
    if (!response)
        return util_1.errorUtil.noResponse();
    // @ts-expect-error deprecated function
    const { errors, data } = response;
    if (errors) {
        return util_1.errorUtil.apiError('', errors);
    }
    return data.userAttributeUpdate;
}
exports.default = updateUserAttributes;
